import React, { useState } from "react";
import Header from "../../components/Header";
import { Outlet, useLocation } from "react-router-dom";
import styles from "./mainLayout.module.scss";
import Sidebar from "../../components/Header/sidebar/Sidebar";
import { connect, useSelector } from "react-redux";
// import { initializeSocket } from "../../helpers/socket";
const MainLayout = () => {
  const [sidebar, setSidebar] = useState(); 
  const location = useLocation();
  const { authToken,user } = useSelector((state) => state.Auth);
   const userId = user?._id || user?.user?._id
  // useEffect(() => {
  //   if (userId) {
  //     initializeSocket(userId);
  //   }
  // }, [userId]);
  return (
    <>
      <div className={`${styles.mainLayout} d-flex align-items-start`}>
        <Sidebar sidebar={sidebar} setSidebar={setSidebar} />
        <main
          className={`${styles.MainBody} ms-auto MainBody position-relative`}
        >
          <Header sidebar={sidebar} setSidebar={setSidebar} />
          <Outlet />
        </main>
      </div>
    </>
  );
};
const mapStateToPros = (state) => {
  return {
    isAuthenticated: state.Auth.authToken,
    user: state.Auth.user,
  };
};
export default connect(mapStateToPros)(MainLayout);
